/** @format */

import {PeriodsModel} from 'components/PeriodSelector/model';

export const SEARCH_DEBOUNCE_TIME = 300;

export const KPI_WIDTH = 136;

export const PERIODS: PeriodsModel[] = [
  {
    key: 'current',
    name: 'Текущий период',
  },
  {
    key: 'quarter',
    name: '3 месяца',
  },
  {
    key: 'month',
    name: 'Месяц',
  },
  {
    key: 'week',
    name: 'Неделя',
  },
];

export const MEDIAPLAN_TYPE_OPTIONS = [
  {value: '', text: 'Все'},
  {value: 'perform', text: 'За клики'},
  {value: 'media', text: 'За показы'},
];
